import { psmAuditDigital } from '../../actionTypes';

const initialState = {
  list: [],
  questions: [],
  currentAudit: null,
  followUp: null,
  deleteList: [],
  loading: false,
  questionsLoading: false,
  currentAuditLoading: false,
  followUpLoading: false,
  saving: false,
  saveSuccess: false,
  saveError: false,
  followUpSaving: false,
  followUpSaveSuccess: false,
  followUpSaveError: false,
  pendingCompanyRedirect: null,
};

export default function psmAuditDigitalReducer(state = initialState, action) {
  switch (action.type) {
    case psmAuditDigital.list.start:
      return { ...state, list: [], loading: true };
    case psmAuditDigital.list.end:
      return { ...state, loading: false, list: action.payload };
    case psmAuditDigital.list.error:
      return { ...state, loading: false };

    case psmAuditDigital.getById.start:
      return { ...state, currentAudit: null, currentAuditLoading: true };
    case psmAuditDigital.getById.end:
      return { ...state, currentAuditLoading: false, currentAudit: action.payload };
    case psmAuditDigital.getById.error:
      return { ...state, currentAuditLoading: false };

    case psmAuditDigital.followUpGet.start:
      return { ...state, followUpLoading: true, followUp: null };
    case psmAuditDigital.followUpGet.end:
      return { ...state, followUpLoading: false, followUp: action.payload };
    case psmAuditDigital.followUpGet.error:
      return { ...state, followUpLoading: false };

    case psmAuditDigital.followUpCreate.start:
    case psmAuditDigital.followUpUpdate.start:
      return {
        ...state,
        followUpSaving: true,
        followUpSaveSuccess: false,
        followUpSaveError: false,
        pendingCompanyRedirect: null,
      };
    case psmAuditDigital.followUpCreate.end:
    case psmAuditDigital.followUpUpdate.end:
      return {
        ...state,
        followUpSaving: false,
        followUpSaveSuccess: true,
        followUpSaveError: false,
        followUp: action.payload,
      };
    case psmAuditDigital.followUpCreate.error:
    case psmAuditDigital.followUpUpdate.error:
      return {
        ...state,
        followUpSaving: false,
        followUpSaveSuccess: false,
        followUpSaveError: true,
        pendingCompanyRedirect: null,
      };

    case psmAuditDigital.pendingCompanyRedirectSet:
      return { ...state, pendingCompanyRedirect: action.payload.companyId };

    case psmAuditDigital.pendingCompanyRedirectClear:
      return { ...state, pendingCompanyRedirect: null };

    case psmAuditDigital.questions.start:
      return { ...state, questionsLoading: true };
    case psmAuditDigital.questions.end:
      return { ...state, questionsLoading: false, questions: action.payload };
    case psmAuditDigital.questions.error:
      return { ...state, questionsLoading: false };

    case psmAuditDigital.create.start:
    case psmAuditDigital.update.start:
      return { ...state, saving: true, saveSuccess: false, saveError: false, pendingCompanyRedirect: null };
    case psmAuditDigital.create.end:
      return {
        ...state,
        saving: false,
        saveSuccess: true,
        saveError: false,
        currentAudit: action.payload || state.currentAudit,
      };
    case psmAuditDigital.update.end:
      return { ...state, saving: false, saveSuccess: true, saveError: false };

    case psmAuditDigital.currentAuditClear:
      return { ...state, currentAudit: null, saveSuccess: false, saveError: false };
    case psmAuditDigital.create.error:
    case psmAuditDigital.update.error:
      return { ...state, saving: false, saveSuccess: false, saveError: true, pendingCompanyRedirect: null };

    case psmAuditDigital.remove.start:
      return { ...state, deleteList: [...state.deleteList, action.payload.auditId] };
    case psmAuditDigital.remove.end:
      return {
        ...state,
        deleteList: state.deleteList.filter(id => id !== action.payload.auditId),
        list: state.list.filter(a => a.id !== action.payload.auditId),
      };
    case psmAuditDigital.remove.error:
      return {
        ...state,
        deleteList: state.deleteList.filter(id => id !== action.payload.auditId),
      };

    case psmAuditDigital.followUpDelete.start:
      return { ...state, deleteList: [...state.deleteList, action.payload.auditFollowUpId] };
    case psmAuditDigital.followUpDelete.end:
      return {
        ...state,
        deleteList: state.deleteList.filter(id => id !== action.payload.auditFollowUpId),
        list: state.list.map(audit =>
          audit.followUp?.id === action.payload.auditFollowUpId ? { ...audit, followUp: null } : audit,
        ),
      };
    case psmAuditDigital.followUpDelete.error:
      return {
        ...state,
        deleteList: state.deleteList.filter(id => id !== action.payload.auditFollowUpId),
      };

    default:
      return state;
  }
}
